import { router, usePage } from '@inertiajs/react'
import { useCanWrite } from '@/lib/access'
import type { SharedProps } from '@/types'
import { t } from '@/lib/i18n'

export type StarterTemplate = {
  key: string
  ic: string
  nm: string
  ds: string
}

/**
 * 空态里的新手模板选择器。点一张卡直接建好「目标 + 步骤 + 奖励」。
 * 只读 / claim 权限的成员看不到——他们不该替别人建目标。
 */
export default function StarterTemplates({ templates }: { templates: StarterTemplate[] }) {
  const canWrite = useCanWrite()
  if (!canWrite || templates.length === 0) return null

  const apply = (key: string) => router.post('/starter_template', { key }, { preserveScroll: true })

  return (
    <div>
      <div className="text-muted text-[13px] mb-3">
        {t('starter_templates.empty_hint')}
      </div>
      <div className="grid gap-2.5 grid-cols-1 sm:grid-cols-2">
        {templates.map((t) => (
          <button
            key={t.key}
            type="button"
            onClick={() => apply(t.key)}
            className="text-left border border-line rounded-xl p-[15px] hover:border-brand transition-colors"
          >
            <div className="font-bold text-[15px]">
              <span className="mr-1.5">{t.ic}</span>
              {t.nm}
            </div>
            <div className="text-muted text-[13px] mt-1">{t.ds}</div>
          </button>
        ))}
      </div>
    </div>
  )
}

/** 应用成功后那一屏顶部的撤销条。flash 是一次性的，导航后自然消失。 */
export function StarterUndoBar() {
  const applied = usePage<SharedProps>().props.flash.starter_applied
  if (!applied) return null

  return (
    <div className="flex items-center gap-2.5 flex-wrap bg-tint border border-brand rounded-xl px-4 py-3 mb-3.5 text-sm">
      <span>{t('starter_templates.applied', { name: applied })}</span>
      <button
        type="button"
        onClick={() => router.delete('/starter_template', { preserveScroll: true })}
        className="font-semibold text-brand underline"
      >
        {t('ledger.reverse')}
      </button>
    </div>
  )
}
